$(document).ready(function () {
	vgCookie.init();

	$('[data-cookie]').click(function () {
		vgCookie.set($(this));

		return false;
	});
});

window.vgCookie = {
	init: function () {
		this.ageLimit();
		this.popupCookie();
	},

	set: function ($self) {
		let cookie = $self.data('cookie'),
			value = $self.data('cookie-value'),
			reload = $self.attr('data-reload') || false;

		if(!$.cookie(cookie) || $.cookie(cookie) === 'undefined') {
			$.cookie(cookie, value, { domain: App.domain, 'path': '/' });

			this.ageLimit(reload);
			this.popupCookie();
		}
	},

	ageLimit: function (reload = false) {
		if($.cookie('age-limit') && $.cookie('age-limit') === 'yes') {
			$('.age-limit').removeClass('age-limit__block--close');

			if (reload) {
				location.reload();
			}
		}
	},

	popupCookie: function () {
		if($.cookie('popup-cookie') && $.cookie('popup-cookie') === 'yes') {
			$('.vg-popup-cookie').removeClass('show');
		} else {
			$('.vg-popup-cookie').addClass('show');
		}
	}
};
